import { Controller } from '@hotwired/stimulus'

const SELECTED_CLASS = 'raven-option-card--selected'
const STEP: Record<string, number> = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }

export default class OptionCardsController extends Controller {
  static targets = ['card', 'input']

  declare readonly cardTargets: HTMLElement[]
  declare readonly inputTarget: HTMLInputElement

  select (event: Event): void {
    this.choose(event.currentTarget as HTMLElement)
  }

  navigate (event: KeyboardEvent): void {
    const current = event.currentTarget as HTMLElement
    const index = this.cardTargets.indexOf(current)

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.choose(current, true)
      return
    }

    if (event.key === 'Home') {
      event.preventDefault()
      this.choose(this.cardTargets[0], true)
      return
    }

    if (event.key === 'End') {
      event.preventDefault()
      this.choose(this.cardTargets[this.cardTargets.length - 1], true)
      return
    }

    const step = STEP[event.key]
    if (!step) {
      return
    }

    event.preventDefault()
    const count = this.cardTargets.length
    this.choose(this.cardTargets[(index + step + count) % count], true)
  }

  private choose (card: HTMLElement, focus: boolean = false): void {
    this.cardTargets.forEach(candidate => {
      const isSelected = candidate === card

      candidate.classList.toggle(SELECTED_CLASS, isSelected)
      candidate.setAttribute('aria-checked', isSelected ? 'true' : 'false')
      candidate.setAttribute('tabindex', isSelected ? '0' : '-1')
    })

    this.inputTarget.value = card.dataset.optionValue ?? ''

    this.inputTarget.dispatchEvent(new CustomEvent('option-cards:change', {
      detail: { value: this.inputTarget.value },
      bubbles: true
    }))

    if (focus) {
      card.focus()
    }
  }
}
